import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    addMessageButton: {
        height: `${rem(30)} !important`,
        display: "flex",
        padding: "0.5rem 0.75rem !important",
        gap: "0.5rem",
    },
}))
